import React from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Stack } from "@fluentui/react";
import { ChecklistActionItemCard } from "./ChecklistActionItemCard";

const ChecklistActionItemsDragAndDropDeck = ({
  actionItems,
  onDragEnd,
  options,
  filteredOptions,
  handleOnActionItemChange,
  handleOnRequirementChange,
  setActionItemToDelete,
  checklist,
  labelLookups,
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="actionItems">
        {(provided) => (
          <div
            key="actionItems"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <Stack
              tokens={{
                childrenGap: 10,
                padding: 10,
              }}
            >
              <DisplayChecklistActionItemCardDeck
                actionItems={actionItems}
                options={options}
                filteredOptions={filteredOptions}
                handleOnActionItemChange={handleOnActionItemChange}
                handleOnRequirementChange={handleOnRequirementChange}
                setActionItemToDelete={setActionItemToDelete}
                checklist={checklist}
                labelLookups={labelLookups}
              />
            </Stack>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const DisplayChecklistActionItemCardDeck = React.memo(
  ({
    actionItems,
    options,
    filteredOptions,
    handleOnActionItemChange,
    handleOnRequirementChange,
    setActionItemToDelete,
    checklist,
    labelLookups,
  }) =>
    actionItems.map((actionItem, index) => (
      <ChecklistActionItemCard
        key={actionItem.key || actionItem.actionItemID}
        actionItemId={actionItem.key || actionItem.actionItemID}
        actionItem={actionItem}
        index={index}
        options={options}
        filteredOptions={filteredOptions}
        actionItems={actionItems}
        handleOnActionItemChange={handleOnActionItemChange}
        handleOnRequirementChange={handleOnRequirementChange}
        setActionItemToDelete={setActionItemToDelete}
        checklist={checklist}
        labelLookups={labelLookups}
      />
    ))
);
export default ChecklistActionItemsDragAndDropDeck;
